import { PooledBenchmarkService } from "../service/asyncBatchPooledBenchmarkService";
import * as validations from "../utils/validations";

export class PooledBenchmarkFunctions {
  fnBurgissCalcPooledBenchmarkIRR(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    startDate?: any,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const startDateValidation = validations.isValidDate(startDate);
    if (startDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid Begin Date parameter.";
    }
    const endDateValidation = validations.isValidDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(startDateValidation, "S");
    if (startDate == null || startDate == "") {
      startDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.startDates[0] != null
          ? defaultMeasuremntDateValues.startDates
          : "";
    } else if (bDate == true) {
      startDate = startDateValidation;
    }
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      endDate = endDateValidation;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date.";
    }
    requireReportedValuation = validations.validateReportedValuation(requireReportedValuation);
    if (requireReportedValuation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    idType = validations.getIdType(idType, "PooledBenchmarkCalc");
    if (String(idType) == "404" || String(idType) == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    weightingMethod = validations.getWeightMethod(weightingMethod);
    if (weightingMethod.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightingMethod.toString().replace("Error", "") + "";
    }
    return new PooledBenchmarkService().burgissCalcPooledBenchmarkIRR(
      investId,
      endDate,
      idType,
      selectionSetId,
      weightingMethod,
      filter,
      baseorlocalcurrency,
      startDate,
      requireReportedValuation,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkTWRR(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    startDate?: any,
    requireReportedValuation?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const startDateValidation = validations.isValidDate(startDate);
    if (startDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid Begin Date parameter.";
    }
    const endDateValidation = validations.isValidDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(startDateValidation, "S");
    if (startDate == null || startDate == "") {
      startDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.startDates[0] != null
          ? defaultMeasuremntDateValues.startDates
          : "";
    } else if (bDate == true) {
      startDate = startDateValidation;
    }
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      endDate = endDateValidation;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date.";
    }
    requireReportedValuation = validations.validateReportedValuation(requireReportedValuation);
    if (requireReportedValuation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    idType = validations.getIdType(idType, "PooledBenchmarkCalc");
    if (String(idType) == "404" || String(idType) == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    weightingMethod = validations.getWeightMethod(weightingMethod);
    if (weightingMethod.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightingMethod.toString().replace("Error", "") + "";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new PooledBenchmarkService().burgissCalcPooledBenchmarkTWRR(
      investId,
      endDate,
      idType,
      selectionSetId,
      weightingMethod,
      filter,
      baseorlocalcurrency,
      startDate,
      requireReportedValuation,
      alternateCurrrency,
      uniqueCellId,
      advancedParameter
    );
  }
}
